export default __webpack_public_path__ + "assets/pdf/RakocziSzovetseg_Adatvedelm_es_Kozerdeku_Adatok_Megismeresenek_Rendejerol_sz_Szabalyzat20211221.pdf";